import React from 'react'
import { BLOCKS, MARKS, INLINES } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Text } from 'rebass'

export const renderToComponents = d => {
  /* eslint-disable */
const options = {
  renderMark: {
    [MARKS.BOLD]: text => (
      <Text is="p" fontWeight="bold">
        {text}
      </Text>
    ),
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => <Text is="p">{children}</Text>,
    [INLINES.ASSET_HYPERLINK]: node =>
      `<img class='custom-asset' src="${
        node.data.target.fields.file['en-US'].url
      }"/>`,
    [INLINES.EMBEDDED_ENTRY]: node => (
      <a href={node.data.target.fields.link['en-US']}>
        {node.data.target.fields.title['en-US']}
      </a>
    ),
  },
};
  /* eslint-enable */
  return documentToReactComponents(JSON.parse(d), options)
}

const wrap = item => {
  if (!item) return false
  return item
}

const extractLevel = node => {
  const { nodeType = '' } = node
  return {
    level: nodeType.split('-')[1],
    nodeType,
  }
}

function removeFalsyValues(item) {
  return Object.keys(item).reduce((acc, k) => {
    if (item[k]) {
      acc[k] = item[k]
    }
    return acc
  }, {})
}

export const RichText = props => {
  const { PARAGRAPH, HEADING, UL, OL, LI, QUOTE, HR, BOLD, ITALIC, UNDERLINE, CODE, A, document } = props

  const options = {
    renderMark: {
      [MARKS.BOLD]: wrap(BOLD),
      [MARKS.ITALIC]: wrap(ITALIC),
      [MARKS.UNDERLINE]: wrap(UNDERLINE),
      [MARKS.CODE]: wrap(CODE),
    },
    renderNode: {
      [INLINES.HYPERLINK]: wrap(A),
      [BLOCKS.HR]: wrap(HR),
      [BLOCKS.LIST_ITEM]: wrap(LI),
      [BLOCKS.OL_LIST]: wrap(OL),
      [BLOCKS.UL_LIST]: wrap(UL),
      [BLOCKS.QUOTE]: wrap(QUOTE),
      [BLOCKS.PARAGRAPH]: wrap(PARAGRAPH),
      [BLOCKS.HEADING_1]: wrap(HEADING) ? (node, ...a) => wrap(HEADING)(...a, ...extractLevel(node)) : false,
      [BLOCKS.HEADING_2]: wrap(HEADING) ? (node, ...a) => wrap(HEADING)(...a, ...extractLevel(node)) : false,
      [BLOCKS.HEADING_3]: wrap(HEADING) ? (node, ...a) => wrap(HEADING)(...a, ...extractLevel(node)) : false,
      [BLOCKS.HEADING_4]: wrap(HEADING) ? (node, ...a) => wrap(HEADING)(...a, ...extractLevel(node)) : false,
      [BLOCKS.HEADING_5]: wrap(HEADING) ? (node, ...a) => wrap(HEADING)(...a, ...extractLevel(node)) : false,
      [BLOCKS.HEADING_6]: wrap(HEADING) ? (node, ...a) => wrap(HEADING)(...a, ...extractLevel(node)) : false,
    },
  }

  return documentToReactComponents(JSON.parse(document), {
    renderMark: removeFalsyValues(options.renderMark),
    renderNode: removeFalsyValues(options.renderNode),
  })
}
